$(document).ready(function () {

    // color switching functionality
    var color_swatch = $('.swatch--flavor .swatch-element');
    var root = document.querySelector(':root');

    color_swatch.on('click', function(event) {
 
        // when clicking on .swatch-name, let it trigger <label>
        if(event.target.matches('.swatch-name') ){
            let opt_label = event.target.closest('.swatch-element').querySelector('label') 
            if (opt_label) opt_label.click()
        }

        var target = event.target.closest('.swatch--flavor .swatch-element');
        var color = $(target).attr('data-color');

        if (color.length > 0) {
            root.style.setProperty('--product-color', color);
        }
    });

    // per serving section variant switching
    var serving_swatch = $('.swatch-element');
    var perServingSection = $('.per-serving-section-container');

    serving_swatch.on('click', function(event) {
        var target = event.target.closest('.swatch-element');

        // when clicking on .swatch-name, let it trigger <label>
        if(event.target.matches('.swatch-name') ){
            let opt_label = event.target.closest('.swatch-element').querySelector('label') 
            if (opt_label) opt_label.click()
        }

        perServingSection.removeClass('active');
        setTimeout(() => {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            var variantId = urlParams.get('variant')
    
            for (var i = 0; i < perServingSection.length; i++) {
                var perServingVariantId = $(perServingSection[i]).attr('data-variant-id');
                
                if (perServingVariantId === variantId) {
                    $(perServingSection[i]).addClass('active');
                }
            }
        }, 100)
    });

    // option input 'change' evt listener
    // let opt_inputs = document.querySelectorAll('.swatch_options input[type="radio"]')
    // opt_inputs.forEach(input => {
    //     input.addEventListener('change', (e)=>{
    //         console.log('e:', e, '  input:', input, ' ', input.checked)
    //         if (input.checked){
    //             let opt_value = input.getAttribute('value')
    //             let opt_grp = input.closest(".swatch")
    //             let labels = opt_grp.querySelectorAll('.swatch-element')
    //             labels.forEach(l => l.classList.remove('selected'))
    //             let target_label = opt_grp.querySelector(`.swatch-element[value="${opt_value}"]`)
    //             target_label.classList.add('selected')
    //         }
    //     })
    // })
    


    // fixed images on scroll
    var imgContainer = $('.gallery-wrap');
    var mobileATC = document.querySelector('.mobile-add-to-cart-container');
    var body = document.querySelector('body')
    var elementTarget = document.querySelector('#atc-offset');
    
    $(window).scroll(function () {

        if ($(window).width() > 798) {
            if ($(this).scrollTop() > 245) {
                imgContainer.addClass('fixed');
            } else {
                imgContainer.removeClass('fixed');
            }
        
            if (imgContainer.offset().top + imgContainer.height() > $('#f-offset').offset().top) {
                imgContainer.removeClass('fixed');
            }
        }

        if ($(window).width() <= 798) {
            if (window.scrollY > (elementTarget.offsetTop + elementTarget.offsetHeight)) {
                mobileATC.classList.add('fixed')
                body.classList.add('fixed')
            } else {
                mobileATC.classList.remove('fixed')
                body.classList.remove('fixed')
            }
        }
    });

    // content accordion section js
    // ------------------------------------------------------
    var $contentAccordionHeading = $('.content-accordion-heading');

    $contentAccordionHeading.on('click', function(event) {
        var target = event.target.closest('.content-accordion-heading');
        $(target).toggleClass('open');
        $(target).next().toggleClass('open');

        // toggle aria expanded attribute
        if ($(target).attr('aria-expanded') === 'true') {
            $(target).attr('aria-expanded', 'false');
        } else {
            $(target).attr('aria-expanded', 'true');
        }
    });
    // ------------------------------------------------------

    // faqs accordion section js
    // -------------------------------------------------------
    var $faqsAccordionHeading = $('.faqs-accordion-heading');

    $faqsAccordionHeading.on('click', function(event) {
        var target = event.target.closest('.faqs-accordion-heading');
        $(target).toggleClass('open');
        $(target).next().toggleClass('open');

        // toggle aria expanded attribute
        if ($(target).attr('aria-expanded') === 'true') {
            $(target).attr('aria-expanded', 'false');
        } else {
            $(target).attr('aria-expanded', 'true');
        }
    });
    // ------------------------------------------------------

    // read more functionality in ingredients section
    // -------------------------------------------------------
    var ingredientsDescription = $('.ingredients-item-text-container');
    var readMoreBtn = $('.read-more');

    readMoreBtn.on('click', function(e) {
        var target = e.target;
        $(target).closest(ingredientsDescription).toggleClass('open');
    })

    // mobile sticky add to cart button smooth scroll
    var mobileCartBtn = $('.mobile-add-to-cart-btn');

    if (mobileCartBtn.length > 0) {

        $(mobileCartBtn).on('click', e => {
            var target = $(e.target.hash);
            if (location.pathname.replace(/^\//, '') === e.target.pathname.replace(/^\//, '') && location.hostname === e.target.hostname) {
                target = target.length ? target : $('[name=' + e.target.hash.slice(1) + ']');

                if (target.length > 0) {
                    e.preventDefault();

                    $('html,body').animate({
                        scrollTop: target.offset().top - 180,
                    }, 800, () => {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        };
                    });
                }
            }
        });
    }

    // vida optima standard section js
    // ------------------------------------------------------
    var cards = $('.vida-optima-standard-cards');

    // init sliders on page
    if (cards.length > 0) {

        cards.slick({
            dots: false,
            arrows: false,
            mobileFirst: true,
            centerMode: false, 
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 350,
                    settings: {
                        centerMode: true,
                        centerPadding: '8%'
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        centerMode: true,
                        centerPadding: '12%'
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        centerMode: true,
                        centerPadding: '15%'
                    }
                },
                {
                    breakpoint: 551,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 798,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1200,
                    settings: "unslick"
                }
            ]
        });  
        
        // match card height functionality
        var card = $('.vida-optima-standard-card');

        if (card.length > 0) {
            var cardText = $('.vida-optima-standard-card-text');
            card.matchHeight();
            cardText.matchHeight();
        }
    }

    // since sliders unslick on desktop, need to check if window has resized to mobile width
    // if resized to mobile, reslick the sliders
    $(window).resize(function() {

        if ($(window).width() < 1200) {

            if ($('.vida-optima-standard-cards:not(.slick-initialized)').length > 0) {

                $('.vida-optima-standard-cards:not(.slick-initialized)').slick({
                    dots: false,
                    arrows: false,
                    mobileFirst: true,
                    centerMode: false, 
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 350,
                            settings: {
                                centerMode: true,
                                centerPadding: '8%'
                            }
                        },
                        {
                            breakpoint: 400,
                            settings: {
                                centerMode: true,
                                centerPadding: '12%'
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                centerMode: true,
                                centerPadding: '15%'
                            }
                        },
                        {
                            breakpoint: 551,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 798,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 1200,
                            settings: "unslick"
                        }
                    ]
                });

                // match card height functionality
                var card = $('.vida-optima-standard-card');

                if (card.length > 0) {
                    var cardText = $('.vida-optima-standard-card-text');
                    card.matchHeight();
                    cardText.matchHeight();
                }
            }
        }
    })
});
